<template>
  <Container class="container-sm-none">
    <Progressbar :step="1" :step-count="model.stepCount">
      Select Policyholder
    </Progressbar>
    <Card class="card-shadow">
      <div class="width-lg">
        <div class="pl-10 pl-md-0 pr-10 pr-md-0">
          <h3 class="heading-3 weight-medium pb-10 pb-md-16 text-left text-md-center">
            Who do you want to insure?
          </h3>

          <Collapse
            v-for="(person, index) in model.insuredPersons.array_hd7ov6$_0"
            :key="index + 1"
            :opened-index="openedIndex"
            @change="setOpened"
            @handle-next-step="handleNextStep"
            @child-loaded="handleCollapseLoaded"
            :tried-go-to-next-step="triedGoToNextStep"
            :index="index"
            :model="model"
            :person-count="model.insuredPersons.array_hd7ov6$_0.length"
            :errors="errors"
          >
            <template v-slot:title>
              <p v-if="person.name && person.surname">
                {{`${person.name} ${person.surname}`}}
              </p>
              <p v-else>
                Policyholder {{`${index + 1}`}}
              </p>
            </template>
            <InsuranceCard
              class="mb-10"
              title='Adult'
              :icon="require('@/assets/svg/adult-person-icon.svg')"
              :enumValue="model.insuredPersons.array_hd7ov6$_0.length > 1 && person.isAdult ? InsuranceType.FAMILY : InsuranceType.ADULT"
              :value="model.insuranceType"
              :person="person"
              @input="selectInsuranceTypeAdult"
            >
              <IconAdultPerson slot="left-icon" />
              <IconRight class="ic-arrow-icon" />
            </InsuranceCard>

            <InsuranceCard
              class="mb-10"
              title='Child Under 18 Years'
              :icon="require('@/assets/svg/horse-icon.svg')"
              :enumValue="model.insuredPersons.array_hd7ov6$_0.length > 1 && !person.isAdult ? InsuranceType.FAMILY : InsuranceType.CHILD"
              :value="model.insuranceType"
              :person="person"
              @input="selectInsuranceTypeChild"
            >
              <IconHorse slot="left-icon" />
              <IconRight class="ic-arrow-icon" />
            </InsuranceCard>

            <InsuranceCard
              v-if="model.insuredPersons.array_hd7ov6$_0.length < 2"
              class="mb-10"
              title='More Persons'
              :enumValue="InsuranceType.FAMILY"
              :value="model.insuranceType"
              :person="person"
              @input="selectInsuranceType"
            >
              <IconPeople slot="left-icon" />
              <Tooltip slot="tooltip">
                <p class="text-left m-0">
                  undefined
                </p>
              </Tooltip>
              <IconRight class="ic-arrow-icon" />
            </InsuranceCard>
          </Collapse>

          <ButtonGroup class="pt-10">
            <Button
              class="btn-outline-tertiary w-full"
              :icon-left="require('@/assets/svg/icon-left-gray.svg')"
              @click="redirectBack"
            >
              Back
            </Button>
          </ButtonGroup>
        </div>
      </div>
    </Card>
  </Container>
</template>

<script>
import distributionChannels from '@/mixins/distributionChannels';
import Card from '@/components/Card/Card.vue';
import routes from '@/mixins/routes';
import ButtonGroup from '@/components/ButtonGroup/ButtonGroup.vue';
import InsuranceCard from '@/components/InsuranceCard/InsuranceCard.vue';
import Container from '@/components/Container/Container.vue';
import Progressbar from '@/components/Progressbar/Progressbar.vue';
import Button from '@/components/Button/Button.vue';
import enums from '@/mixins/enums';
import IconRight from '@/components/Icons/IconRight.vue';
import IconAdultPerson from '@/components/Icons/IconAdultPerson.vue';
import IconHorse from '@/components/Icons/IconHorse.vue';
import IconPeople from '@/components/Icons/IconPeople.vue';
import Collapse from '@/components/Collapse/Collapse.vue';
import GA from '@/mixins/GA';
import Tooltip from '@/components/Tooltip/Tooltip.vue';

export default {
  name: 'InsuranceTypePage',
  mixins: [distributionChannels, enums, routes, GA],
  components: {
    Collapse,
    ButtonGroup,
    Button,
    InsuranceCard,
    Card,
    Container,
    Progressbar,
    IconRight,
    IconAdultPerson,
    IconHorse,
    IconPeople,
    Tooltip,
  },
  data() {
    return {
      openedIndex: -1,
      triedGoToNextStep: false,
    };
  },
  props: {
    model: { type: Object, required: true },
    errors: { type: Array, required: true },
  },
  computed: {
    InsuranceType() { return this.enums.InsuranceTypeEnum; },
  },
  methods: {
    selectInsuranceTypeAdult(type, person) {
      if (this.model.insuredPersons.array_hd7ov6$_0.length > 1) {
        this.model.insuranceType = this.InsuranceType.FAMILY;
      } else {
        this.model.insuranceType = type;
      }

      person.isAdult = true;
      person.insuranceType = this.InsuranceType.ADULT;
      this.model.stepCount = 11;

      setTimeout(() => this.redirectToNext(), 500);
    },
    selectInsuranceTypeChild(type, person) {
      if (this.model.insuredPersons.array_hd7ov6$_0.length > 1) {
        this.model.insuranceType = this.InsuranceType.FAMILY;
      } else {
        this.model.insuranceType = type;
      }

      person.isAdult = false;
      person.insuranceType = this.InsuranceType.CHILD;
      this.model.stepCount = 13;

      setTimeout(() => this.redirectToNext(), 500);
    },
    selectInsuranceType(type, person) {
      if (this.model.insuredPersons.array_hd7ov6$_0.length > 1) {
        this.model.insuranceType = this.InsuranceType.FAMILY;
      } else {
        this.model.insuranceType = type;
      }
      if (type === this.InsuranceType.CHILD) {
        person.isAdult = false;
        person.insuranceType = this.InsuranceType.CHILD;
        this.model.stepCount = 13;
      } else {
        person.isAdult = true;
        person.insuranceType = this.InsuranceType.ADULT;
        this.model.stepCount = 11;
      }
      setTimeout(() => this.redirectToNext(), 500);
    },
    redirectToNext() {
      this.triedGoToNextStep = true;
      if (this.errors.length === 0) {
        if (!this.model.insuredPersons.array_hd7ov6$_0[this.model.currentPersonIndex].visitedSteps.array_hd7ov6$_0.includes(this.getNearestNextAvailableStep())) {
          this.model.insuredPersons.array_hd7ov6$_0[this.model.currentPersonIndex].visitedSteps.array_hd7ov6$_0.push(this.getNearestNextAvailableStep());
        }
        this.model.currentPersonStepIndex += 1;
        this.$router.goToStep(this.getNearestNextAvailableStep());
      }
    },
    redirectBack() {
      this.$router.goToStep(this.getNearestPreviousAvailableStep());
    },
    handleCollapseLoaded() {
      this.openedIndex = this.model.currentPersonIndex;
    },
    handleNextStep() {
      this.triedGoToNextStep = false;
    },
    setOpened(index) {
      this.openedIndex = index;
    },
  },
  created() {
    this.model.step = 2;
    if (this.model.lastStep < 2) this.model.lastStep = 2;
  },
  mounted() {
    this.funnelStep('Výber poistenca');
  },
};
</script>
